export type TypographyType =
  | 'callout1'
  | 'callout2'
  | 'subHeadline'
  | 'headline'
  | 'title3'
  | 'title2'
  | 'title1'
  | 'body'
  | 'caption1'
  | 'caption2'
  | 'overline1'
  | 'overline2'
  | 'overline3'
  | 'footnote';

export enum DisclosureDirection {
  LEFT,
  RIGHT,
}

export type ButtonVariantType = 'primary' | 'secondary' | 'text';

export type ButtonSizeType = 'small' | 'medium' | 'large';
